<template>
    <div>
        <iframe src="http://118.25.85.189:8086/index.html" style="width: 100%; height: 100vh; border: none;"></iframe>
    </div>
</template>

<script>
export default {
}
</script>

<style>
</style>